/**
 * Badge "Régime CCQ" / "Hors CCQ" — Phase 6 Module CCQ (2026-05-06).
 * Affiché sur les lignes de punch, rapports d'heures, stats client, Mon Espace.
 */
import { Badge } from './ui/badge';
import { AlertTriangle } from 'lucide-react';

/**
 * Props attendues :
 * - regime: "ccq" | "hors_ccq" | undefined → si undefined, rien n'est affiché
 * - requiresReview: bool — si true, ajoute un avertissement rouge "Grade manquant"
 * - size: "xs" | "sm" (défaut "xs")
 * - className: classes additionnelles
 */
export function RegimeBadge({ regime, requiresReview, size = 'xs', className = '' }) {
  if (!regime) return null;
  const sizeCls = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-[10px] px-1.5 py-0.5';

  if (regime === 'ccq') {
    return (
      <Badge
        className={`${sizeCls} bg-violet-100 text-violet-800 hover:bg-violet-100 border border-violet-300 font-semibold ${className}`}
        data-testid="badge-regime-ccq"
      >
        🏛️ CCQ
        {requiresReview && (
          <span className="ml-1 inline-flex items-center text-red-600" title="Grade CCQ manquant — révision manuelle requise">
            <AlertTriangle className="w-3 h-3" />
          </span>
        )}
      </Badge>
    );
  }
  return (
    <Badge
      className={`${sizeCls} bg-slate-100 text-slate-700 hover:bg-slate-100 border border-slate-300 font-medium ${className}`}
      data-testid="badge-regime-hors-ccq"
    >
      🏠 Hors CCQ
    </Badge>
  );
}

/**
 * Helper fonction pour usage dans les tableaux ou tooltips.
 * Retourne juste le label texte selon le régime.
 */
export function regimeLabel(regime) {
  if (regime === 'ccq') return 'CCQ (commercial)';
  return 'Hors CCQ (résidentiel)';
}
